export default {"src":"/_next/static/media/roadwise-logo-dark-fr.e5a4d2fc.svg","height":47,"width":109,"blurWidth":0,"blurHeight":0};